import { render, staticRenderFns } from "./registrationModal.vue?vue&type=template&id=7b185dfc"
import script from "./registrationModal.vue?vue&type=script&lang=js"
export * from "./registrationModal.vue?vue&type=script&lang=js"
import style0 from "./registrationModal.vue?vue&type=style&index=0&id=7b185dfc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b185dfc')) {
      api.createRecord('7b185dfc', component.options)
    } else {
      api.reload('7b185dfc', component.options)
    }
    module.hot.accept("./registrationModal.vue?vue&type=template&id=7b185dfc", function () {
      api.rerender('7b185dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/registrationQuery/views/registrationModal.vue"
export default component.exports